import { render, staticRenderFns } from "./ToplamBekleyenSiparisTutari.vue?vue&type=template&id=df2fb9b6&scoped=true"
import script from "./ToplamBekleyenSiparisTutari.vue?vue&type=script&lang=js"
export * from "./ToplamBekleyenSiparisTutari.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df2fb9b6",
  null
  
)

export default component.exports